import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_ALL_FOLLOWUP,
  GET_FOLLOWUP_DETAILS,
  CREATE_FOLLOWUP,
  UPDATE_FOLLOWUP,
  DELETE_FOLLOWUP,
} from "./actionTypes"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"
import {
  createFollowUpFail,
  createFollowUpSuccess,
  deleteFollowUpFail,
  deleteFollowUpSuccess,
  getAllFollowUpFail,
  getAllFollowUpSuccess,
  getFollowUpDetailsFail,
  getFollowUpDetailsSuccess,
  updateFollowUpFail,
  updateFollowUpSuccess,
} from "./actions"

//   - This line cannot be edited or removed
function getFollowUpApi({
  page,
  filter,
  limit,
  StaffId,
  finalDateFormated,
  leadId,
  clientId,
  branchId,
}) {
  const query = new URLSearchParams({
    page: page || 1,
    limit: limit || 10,
    assignee: StaffId || "",
    from: finalDateFormated?.from || "",
    to: finalDateFormated?.to || "",
    lead: leadId || "",
    client: clientId || "",
    branch: branchId || "",
    filter: filter || "",
  })

  return get(`/followUp/admin/all/?${query.toString()}`)
}

const getFollowUpDetailsAPi = clientId => {
  return get(`/client/admin/${clientId}`)
}

const createFollowUpApi = ({ followUps }) => {
  return post("/followUp/admin/new", followUps)
}

const updateFollowUpApi = ({ followUps, followUpId }) => {
  return ApiPut(`/followUp/admin/${followUpId}`, followUps)
}

const deleteFollowUpApi = ({ clientId }) => {
  return del(`/followUp/admin/${clientId}`)
}

function* fetchFollowUp({ payload }) {
  try {
    const response = yield call(getFollowUpApi, payload)
    yield put(getAllFollowUpSuccess(response))
  } catch (error) {
    yield put(getAllFollowUpFail(error))
  }
}

function* fetchFollowUpDetails({ payload: clientId }) {
  try {
    const response = yield call(getFollowUpDetailsAPi, clientId)
    yield put(getFollowUpDetailsSuccess(response))
  } catch (error) {
    yield put(getFollowUpDetailsFail(error))
  }
}

function* onCreateFollowUp({ payload }) {
  try {
    const response = yield call(createFollowUpApi, payload)

    yield put(createFollowUpSuccess(response))
    payload?.onCloseClick()
    doneNotification("FollowUp Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createFollowUpFail(error))
  }
}

function* onUpdateFollowUp({ payload }) {
  try {
    const response = yield call(updateFollowUpApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "FollowUp Updated Successfully!",
        title: "",
      })
      yield put(updateFollowUpSuccess(response))
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateFollowUpFail(error.response.data))
  }
}

function* onDeleteFollowUp({ payload }) {
  try {
    const response = yield call(deleteFollowUpApi, payload)
    yield put(deleteFollowUpSuccess(response))
    doneNotification("Client Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteFollowUpFail(error?.response?.data))
  }
}

function* FollowUpSaga() {
  yield takeEvery(GET_ALL_FOLLOWUP, fetchFollowUp)
  yield takeEvery(GET_FOLLOWUP_DETAILS, fetchFollowUpDetails)
  yield takeEvery(CREATE_FOLLOWUP, onCreateFollowUp)
  yield takeEvery(UPDATE_FOLLOWUP, onUpdateFollowUp)
  yield takeEvery(DELETE_FOLLOWUP, onDeleteFollowUp)
}

export default FollowUpSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
